import scrollMove from '@/src/module/jhc-scrollMove';
import anime from 'animejs/lib/anime.es.js';
import qs from 'qs';
import React from 'react';

export default class SubmitWrite extends React.Component {

	constructor (props) {
		super(props);
		this.state={
      status: false
    }
	}

	finalSubmit () {
		const finalData= this.encodingDatas(this.props.submitData);
		// this.formData.append('query', qs.stringify(finalData));
		
		this.props.onSave('loading');
		console.dir(qs.stringify(finalData))
	  axios({
			url: '/controllers/trial',
			method: 'POST',
			data: qs.stringify(finalData)
		})
		.then( res=> {
			console.dir(res)
			if(res.data == 'success') {
				this.props.onSave(true);
			} else {
				this.props.onSave('error!');
				// this.setStatus(null, 'error!');
			}
		});
	}

	twolength(n) { return (n < 10 ? '0' : '') + n }

	encodingDatas ( datas ) {
		this.formData = new FormData();
		const finalData= {};
		Object.keys(datas).some( (key)=> {
      // finalData[key]= this.props.submitData[key].value;
	  	switch (key) {
			  default:
			    finalData[key]= this.props.submitData[key].value;
			    break;
			}
		});
		return finalData;
	}

	handlerSubmit= (e)=> {
    const data= this.props.submitData;
		let loop= false;
		console.dir(data);
		Object.keys(data).some( (key)=> {

	    switch (key) {
			  case 'trial_ios':
				case 'trial_android':
					if( !data[key].value ) {
						loop= this.errEvent(key);
						return loop;
					}
					if( !data[key].validity ) {
						loop= this.errEvent(key, `${this.props.submitData[key].nameKr} 유효성 에러`);
						return loop;
					}
					break;

			  default:
			    if( data[key].require !== false && !data[key].value ) {
			    	loop= this.errEvent(key);
			    }
			    break;
			}

			return loop;

		});
	  if( !loop ) this.finalSubmit();
	}

	errEvent (key, msg) {
  	const elem= this.props.submitData[key].elem;
  	// scrollMove(elem, 500, 500);
		scrollMove(elem, 500, 500, null, this.props.wrapper.current);
		anime({
			targets: elem,
			duration: 1000,
			delay: 500,
			direction: 'alternate',
			borderColor: '#f00',
			borderWidth: '10px',
			padding: '20px',
		});
    return this.setStatus(key, msg);
	}

	setStatus (key, msg) {
    if( this.timer ) clearTimeout(this.timer);
		this.timer= null;

		if( msg ) { 
			msg= msg;
		} else {
			const status= this.props.submitData[key].nameKr;
		  const josa= typeof status == 'string' ? this.josaFilter(status) : '';
		  msg= `${status}${josa} 입력해주세요.`;
		}
		this.setState({
  		status: msg
  	});
  	this.timer= setTimeout((e)=> { 
  		this.setState({ status: false });
  		clearTimeout(this.timer);
  	}, 2000);

  	return true;
	}

	josaFilter ( str ) {
		var code = str.charCodeAt(str.length-1) - 44032
			, josa= (code % 28 === 0) ? '를' : '을';
		return josa;
	}

	render() {
    let statusMsg;
    const status= this.state.status;
		switch (status) {
		  case false:
		    break;
		  default:
		    statusMsg= `${status}`;
		    break;
		}

		return (
			<div>

				<p className={`${statusMsg && 'fadeOut tr-10 tr-d10'} ft1 m-ft1 ft-rd ft-b mg-h0`}>
				 {statusMsg}
				</p>

				<div className="submit-area m-w100 pd-t20">
					<button 
						onClick={this.handlerSubmit} 
						className="bg-clr-5 ft-wh pd-s20 pd-h10 bd-rd-5 ft3 ft-b inst-box block-box cursor-point"
					>
						신청하기
					</button>
				</div>

			</div>
		);
	}
}